"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
require("pepjs");
const client_1 = require("react-dom/client");
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const app_1 = require("~/app");
const context_1 = require("~/auth/context");
const Holder_1 = require("~/utils/Holder");
const GameSessionHolder_1 = require("./game/GameSessionHolder");
const sessionContext_1 = require("./game/sessionContext");
const creatureDefinitions_1 = require("./networking/creatureDefinitions");
const context_2 = require("./networking/context");
const plugins_1 = require("./plugins");
const SplashScreen_1 = require("./components/SplashScreen");
const bootEntrance_1 = require("./components/menu/bootEntrance");
const store_1 = require("./store");
const useStyles_1 = require("./useStyles");
/**
 * Runs once while the splash is still covering the app: rejoins an existing
 * game/lobby if the player has one, then signals the boot sequence to reveal
 * whatever surface the store now points at (game, lobby, or menu).
 */
function BootReconnect({ onReady }) {
    const socketManager = (0, context_2.useSocketManager)();
    const startedRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (startedRef.current) {
            return;
        }
        startedRef.current = true;
        socketManager.reconnectToExistingGame().then((found) => onReady(found), () => onReady(false));
    }, [socketManager, onReady]);
    return null;
}
function AppRoot({ onReady }) {
    const sessionHolderRef = (0, react_1.useRef)(null);
    if (sessionHolderRef.current === null) {
        sessionHolderRef.current = new GameSessionHolder_1.GameSessionHolder();
    }
    const gameConnectionHolderRef = (0, react_1.useRef)(null);
    if (gameConnectionHolderRef.current === null) {
        gameConnectionHolderRef.current = new Holder_1.Holder("GameConnection");
    }
    const lobbyConnectionHolderRef = (0, react_1.useRef)(null);
    if (lobbyConnectionHolderRef.current === null) {
        lobbyConnectionHolderRef.current = new Holder_1.Holder("LobbyConnection");
    }
    const accountIdHolderRef = (0, react_1.useRef)(null);
    if (accountIdHolderRef.current === null) {
        accountIdHolderRef.current = new Holder_1.Holder("AccountId");
    }
    const socketManagerHolderRef = (0, react_1.useRef)(null);
    if (socketManagerHolderRef.current === null) {
        socketManagerHolderRef.current = new Holder_1.Holder("SocketManager");
    }
    const storeRef = (0, react_1.useRef)(null);
    if (storeRef.current === null) {
        storeRef.current = (0, store_1.createAppStore)({
            sessionHolder: sessionHolderRef.current,
            gameConnectionHolder: gameConnectionHolderRef.current,
            lobbyConnectionHolder: lobbyConnectionHolderRef.current,
            accountIdHolder: accountIdHolderRef.current,
            socketManagerHolder: socketManagerHolderRef.current,
        });
        (0, plugins_1.wirePluginHostState)({
            store: storeRef.current,
            getLocalPlayerId: () => { var _a, _b; return (_b = (_a = accountIdHolderRef.current) === null || _a === void 0 ? void 0 : _a.peek()) !== null && _b !== void 0 ? _b : null; },
        });
    }
    return (React.createElement(react_redux_1.Provider, { store: storeRef.current },
        React.createElement(context_1.AccountIdHolderProvider, { value: accountIdHolderRef.current },
            React.createElement(sessionContext_1.GameSessionProvider, { holder: sessionHolderRef.current },
                React.createElement(context_2.SocketManagerProvider, { gameConnectionHolder: gameConnectionHolderRef.current, lobbyConnectionHolder: lobbyConnectionHolderRef.current, accountIdHolder: accountIdHolderRef.current, socketManagerHolder: socketManagerHolderRef.current },
                    React.createElement(react_jss_1.ThemeProvider, { theme: useStyles_1.DEFAULT_THEME },
                        onReady && React.createElement(BootReconnect, { onReady: onReady }),
                        React.createElement(app_1.App, null)))))));
}
const MIN_SPLASH_MS = 1200;
function Boot() {
    const [phase, setPhase] = (0, react_1.useState)("loading");
    // True when the reconnect check dropped us straight into a game/lobby, so the
    // splash fades out wholesale instead of crossfading into the menu.
    const [reconnected, setReconnected] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let cancelled = false;
        const load = () => __awaiter(this, void 0, void 0, function* () {
            (0, plugins_1.installPluginRuntime)();
            // Pre-game surfaces (menu, lobby) need creature art before any connection.
            const catalogUrl = APP_PLUGIN_MANIFEST_URL.replace(/manifest\.json$/, "creatures.json");
            yield Promise.all([
                (0, creatureDefinitions_1.loadCreatureCatalog)(catalogUrl),
                (0, plugins_1.loadClientPlugins)(APP_PLUGIN_MANIFEST_URL),
                new Promise((resolve) => setTimeout(resolve, MIN_SPLASH_MS)),
            ]);
        });
        load()
            .then(() => {
            if (!cancelled) {
                setPhase("reconnecting");
            }
        })
            .catch((error) => {
            // eslint-disable-next-line no-console
            console.error("[bootstrap] failed before menu", error);
            if (!cancelled) {
                setPhase("error");
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (phase !== "entering") {
            return;
        }
        const total = reconnected ? bootEntrance_1.BOOT_GAME_FADE_MS : bootEntrance_1.BOOT_TRANSITION_TOTAL_MS;
        const timer = setTimeout(() => setPhase("done"), total);
        return () => clearTimeout(timer);
    }, [phase, reconnected]);
    const onReconnectChecked = React.useCallback((foundGame) => {
        setReconnected(foundGame);
        setPhase((current) => (current === "reconnecting" ? "entering" : current));
    }, []);
    if (phase === "error") {
        return (React.createElement("div", { style: { padding: 24, fontFamily: "sans-serif" } }, "Something went wrong while starting the game. Please refresh to try again."));
    }
    return (
    // The splash sits outside AppRoot's providers, so it needs its own theme.
    React.createElement(react_jss_1.ThemeProvider, { theme: useStyles_1.DEFAULT_THEME },
        phase !== "loading" && (React.createElement(bootEntrance_1.BootEntranceContext.Provider, { value: phase === "entering" },
            React.createElement(AppRoot, { onReady: phase === "reconnecting" ? onReconnectChecked : undefined }))),
        phase !== "done" && (React.createElement(SplashScreen_1.SplashScreen, { entering: phase === "entering", mode: reconnected ? "game" : "menu" }))));
}
const container = document.getElementById("approot");
if (container) {
    (0, client_1.createRoot)(container).render(React.createElement(Boot, null));
}
